import { env } from "@/services/env.service";

const ASSETS_BASE_URL = env.REACT_APP_API;

/**
 * Returns the full image URL, handling both absolute and relative paths.
 */
export const getImageSRC = (src: string): string => {
  return src.indexOf("://") === -1 ? `${ASSETS_BASE_URL}${src}` : src;
};

/**
 * Extracts the file extension/mime type from a content type string.
 */
export const getMimeType = (
  type: string | null | undefined,
): string | undefined => {
  if (type) {
    const temp = type.split("/");
    return temp.pop();
  }
  return undefined;
};
